module.exports = __webpack_public_path__ + "static/basic-flow_5-3d439b92af498fbf532dfd5254d62372.png";